import { ColoursObj } from "@eventr/common-storybook";
import { Box, Stack } from "@mui/material";
import React, { useState } from "react";
import { AccordionTransition } from "common/AccordionTransition";
import { Expand } from "home/components/Expand";
import { useObjectContext } from "../providers/objectProvider";

interface IExpandableSectionProps {
  children?: React.ReactNode;
  mid?: React.ReactNode;
  end?: React.ReactNode;
  arrowPosition?: "left" | "right";
}
export const ExpandableSection = ({ children, mid, end, arrowPosition = "left" }: IExpandableSectionProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const { past } = useObjectContext();
  return (
    <Box x-sp-c="ListKeyPoint">
      <Stack
        direction="row"
        onClick={(e) => {
          setOpen((o) => !o);
          e.stopPropagation();
        }}
        sx={{
          justifyContent: "space-between",
          alignItems: "center"
        }}>
        {arrowPosition === "left" && (
          <>
            <Stack spacing="16px" direction="row">
              <Expand expanded={open} past={past} colour={ColoursObj.font.primary} />
              {mid}
            </Stack>
            {end}
          </>
        )}
        {arrowPosition === "right" && (
          <>
            <Stack spacing="16px" direction="row">
              {mid}
              {end}
            </Stack>

            <Expand expanded={open} past={past} colour={ColoursObj.font.primary} />
          </>
        )}
      </Stack>
      <Box
        style={{
          padding: "10px 0 0 0",
          maxHeight: open ? "unset" : "0px",
          overflow: "hidden",
          transition: "ease 0.2s",
        }}
      >
        <AccordionTransition open={open}>{children}</AccordionTransition>
      </Box>
    </Box>
  );
};
